// src/components/Footer.js

import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaPinterestP,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import { FaCopyright } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../styles/footer.css";
import RonniLogo from "../assets/whitelogo.png";

function Footer() {
  const address = "Objekti BK Center(Kati 1), Rr."; // Store the address
  const phone1 = "+38344555951"; // Store phone numbers
  const phone2 = "+38346192921";
  const email = "roniceramics@gmail.com";

  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    address
  )}`; // Construct Google Maps URL

  return (
    <footer>
      <div className="footer-container">
        <div className="footer-column">
          <div className="footer-logo">
            <a href="/">
              <img
                src={RonniLogo}
                alt="Ronni Ceramics Logo"
                className="ronni-logo"
              />
            </a>
          </div>
          <p>
            Zgjidhni nga një zgjedhje e gjerë pllakash seramike në kataloge të
            ndryshme, madhësi, ngjyra dhe forma për t'i përshtatur çdo
            preferencë dizajni.
          </p>
        </div>

        <div className="footer-column">
          <h3>KONTAKTONI</h3>
          <p>
            <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
              <FaMapMarkerAlt /> {address}
            </a>
          </p>
          <p>
            <a href={`tel:${phone1}`}>
              <FaPhone /> {phone1}
            </a>
          </p>
          <p>
            <a href={`tel:${phone2}`}>
              <FaPhone /> {phone2}
            </a>
          </p>
          <p>
            <a href={`mailto:${email}`}>
              <FaEnvelope /> {email}
            </a>
          </p>
        </div>

        <div className="footer-column">
          <h3>SHËRBIMET</h3>
          <ul>
            <li>
              <Link to="/">Shtëpia</Link>
            </li>
            <li>
              <Link to="/shop">Dyqani</Link>
            </li>
            <li>
              <Link to="/about">Rreth Nesh</Link>
            </li>
            <li>
              <Link to="/contact">Na Kontaktoni</Link>
            </li>
            <li>
              <Link to="/terms">Terms & Conditions</Link>
            </li>
            {/* Added Terms & Conditions */}
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            {/* Added Privacy Policy */}
          </ul>
        </div>

        <div className="footer-column">
          <h3>TË REJAT</h3>
          <p>Filloni të blini me ne tani dhe përfitoni zbritje të rregullta.</p>
          <div className="footer-social">
            <a href="#">
              <FaFacebookF />
            </a>
            <a href="#">
              <FaTwitter />
            </a>
            <a href="#">
              <FaPinterestP />
            </a>
            <a href="#">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <FaCopyright /> 2024 RonniCeramics. Created by{" "}
        <a
          href="https://shigjeta.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Shigjeta
        </a>
      </div>
    </footer>
  );
}

export default Footer;
